export const dataLibR = [{
  word: 'radyo',
  partOfSpeech: 'N',
  definition: ['radio'],
  egSentenceKw: 'Nou tann nouvèl-la asou radyo-a.',
  egSentenceEn: 'We heard the news on the radio.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. radio]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'roti',
  partOfSpeech: 'N',
  definition: ['East Indian flat bread'],
  egSentenceKw: 'Mwen enmen roti lè i cho.',
  egSentenceEn: 'I like rotis when they are hot.',
  synonym: ['bék'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'rèkòd',
  partOfSpeech: 'N',
  definition: ['record'],
  egSentenceKw: 'Gwoup-la fè on rèkòd.',
  egSentenceEn: 'The group made a record.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. record]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'roro',
  partOfSpeech: 'N',
  definition: ['uproar', 'tumult'],
  egSentenceKw: 'La té ni an gwo roro.',
  egSentenceEn: 'There was a big uproar.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. row]',
  dialect: '🇱🇨',
  variant: [null],
},
];
